// Simple event emitter for dashboard refresh with localStorage persistence
import { useEffect } from 'react';

class DashboardRefreshEmitter {
  constructor() {
    this.listeners = [];
  }

  subscribe(callback) {
    // Immediately add listener
    this.listeners.push(callback);
    
    // Check if there's a pending refresh in localStorage
    const lastRefresh = localStorage.getItem('dashboardRefreshFlag');
    if (lastRefresh) {
      // Trigger callback for pending refresh
      setTimeout(() => callback(), 0);
    }
    
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  emit() {
    // Call all listeners immediately
    this.listeners.forEach(callback => callback());
    
    // Also store in localStorage so Dashboard can check on mount
    localStorage.setItem('dashboardRefreshFlag', Date.now().toString());
  }
}

export const dashboardRefreshEmitter = new DashboardRefreshEmitter();

export const useDashboardRefresh = (callback) => {
  useEffect(() => {
    return dashboardRefreshEmitter.subscribe(callback);
  }, [callback]);
};
